import {getAllCustomerMain} from '../../services/CustomerMainServices'

export function formatSiteNameWithAddress(site = {}) {
  const parts = [site.site_name, site.address_1, site.address_2, site.address_3]
    .map((value) => (value ? String(value).trim() : ''))
    .filter(Boolean);
  return parts.join(', ');
}

export function formatSiteProjectName(site = {}) {
  return site.project_name ? String(site.project_name).trim() : '';
}

export function getSiteStats(site = {}) {
  return {
    no_of_quotation: site.no_of_quotation ?? 0,
    no_of_order: site.no_of_order ?? 0,
    no_of_schedule: site.no_of_schedule ?? 0,
    no_of_dc: site.no_of_dc ?? 0,
    total_qty: site.total_qty ?? 0,
  };
}

export function getUpDownKm(site = {}) {
  const oneWayKm = Number(site.radius_distance || 0);
  return Number.isFinite(oneWayKm) ? (oneWayKm * 2).toFixed(2) : '0.00';
}

export function checkDuplicateCustomerMain(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
        getAllCustomerMain(cookies)
      .then((data) => {

        let isUserExists = false;
        data.customer_list.forEach(customer =>{ //Same Customer Name mentioned it denoted already exist.
        
          if((customer.name) === value.trim().toUpperCase()
            && parseInt(existingId) !== customer.id){   
            
            console.log(`Customer exists with the name - ${value}`) 
            isUserExists = true;
       
          }
        
      })
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }